import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [status, setStatus] = useState({ type: null, message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    // Honey pot check (bots fill hidden fields)
    if (formData.get('website')) {
      setStatus({
        type: 'error',
        message: 'Die Anfrage konnte nicht gesendet werden. Bitte versuche es erneut.',
      });
      return;
    }

    const name = (formData.get('name') || '').trim();
    const email = (formData.get('email') || '').trim();

    if (!name || !email) {
      setStatus({
        type: 'error',
        message: 'Bitte gib sowohl deinen Namen als auch deine E-Mail-Adresse an.',
      });

      const targetField = !name ? event.target.elements.name : event.target.elements.email;
      targetField?.focus();
      return;
    }

    setIsSubmitting(true);
    setStatus({ type: null, message: '' });

    try {
      const response = await fetch('/contact.php', {
        method: 'POST',
        body: formData,
      });

      let result;
      try {
        result = await response.json();
      } catch (parseError) {
        result = null;
      }

      if (!response.ok || !(result && result.success)) {
        const errorMessage = result && result.message
          ? result.message
          : 'Beim Senden ist ein Fehler aufgetreten.';
        throw new Error(errorMessage);
      }

      setStatus({
        type: 'success',
        message: 'Danke für deine Nachricht! Ich melde mich so schnell wie möglich.',
      });
      event.target.reset();
    } catch (error) {
      setStatus({
        type: 'error',
        message: error.message || 'Beim Senden ist ein Fehler aufgetreten.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="kontakt" className="contact">
      <div className="contact-container">
        <h2>Kontakt</h2>
        <div className="contact-content">
          <div className="contact-form-wrapper">
            <form className="contact-form" onSubmit={handleSubmit} noValidate>
              <div aria-hidden="true" className="hidden-field-wrapper">
                <label htmlFor="website-field">Bitte nicht ausfüllen</label>
                <input id="website-field" type="text" name="website" tabIndex="-1" autoComplete="off" />
              </div>
              <div className="form-group">
                <input type="text" name="name" placeholder="Name" required />
              </div>
              <div className="form-group">
                <input type="email" name="email" placeholder="E-Mail" required />
              </div>
              <div className="form-group">
                <input type="tel" name="phone" placeholder="Telefon" />
              </div>
              <div className="form-group">
                <textarea name="message" placeholder="Nachricht" rows="6"></textarea>
              </div>
              <button type="submit" className="btn-primary" disabled={isSubmitting}>
                {isSubmitting ? 'Wird gesendet…' : 'Absenden'}
              </button>
              {status.type && (
                <p className={`form-status form-status--${status.type}`}>
                  {status.message}
                </p>
              )}
            </form>
          </div>
          <div className="contact-image">
            <img src="/img/kontakt.jpg" alt="Kontakt" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
